"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
require("jquery");
class ContentArea extends React.Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this._loadedBackupContentArea = false;
        this.state = {
            contentarea: null,
            content: props.content,
            area: props.area,
            loading: false,
            language: props.language
        };
    }
    imagescaling(data) {
        var hData = $(data);
        var bgs = hData.find('*[data-scaling-bg]');
        bgs.each(function (i) {
            var parentscaling = $(this).attr('data-parent-scaling');
            if (parentscaling != undefined && parentscaling) {
                var src = $(this).attr('data-scaling-bg') + '?width=' + $(this).parent().width();
            }
            else {
                //TODO Fix the image scaling?
                var src = $(this).attr('data-scaling-bg') + '?width=' + Math.ceil($(this).width());
            }
            $(this).css('background-image', 'url(' + src + ')');
            $(this).removeAttr("data-scaling-bg");
        });
        //Add the "row" class to the outer div so that the block inside the content area are displayed correctly
        hData.addClass('row');
        //Apply styles of the inner div for background color. Equivalent to the script in index.ts
        hData.find('.block').each(function () {
            if ($(this).parent().hasClass('fullbleed')) {
                let style = $(this).attr('style') || "";
                style += $(this).children(':first').attr('style') || "";
                $(this).attr('style', style);
                if ($(this).find('.image-content-block--has-bg-color').length > 0)
                    $(this).addClass('_sm-u-py-4');
            }
        });
        return $('<div>').append(hData).clone().html();
    }
    componentDidMount() {
        this._isMounted = true;
        this.LoadContentArea();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (this.props.content !== prevProps.content) {
            this._loadedBackupContentArea = false;
            this.LoadContentArea(this.props.content);
        }
        let body = $('body');
        let dangerous = body.find('script.dangerous_react_rendered');
        let clones = dangerous.clone();
        clones.removeClass('dangerous_react_rendered').addClass('came_from_react_render');
        dangerous.remove();
        body.append(clones.prop('outerHTML'));
    }
    LoadContentArea(content, area) {
        var imageScaling = this.imagescaling;
        this.setState({
            loading: true
        }, () => $.ajax({
            type: "GET",
            url: "/Render/RenderContentArea",
            data: {
                "content": content || this.state.content,
                "area": area || this.state.area,
                "language": this.state.language
            },
            success: function (data) {
                if (this._isMounted) {
                    if (!data && this.props.backupArea && this.props.backupContent && this._loadedBackupContentArea === false) {
                        this._loadedBackupContentArea = true;
                        this.LoadContentArea(this.props.backupContent, this.props.backupArea);
                    }
                    else {
                        this.setState({ contentarea: imageScaling(data), loading: false });
                    }
                }
            }.bind(this),
            error: function () {
            }.bind(this)
        }));
    }
    render() {
        //in case there are scripts in the content area blocks
        let contents = $(this.state.contentarea);
        let scripts = contents.find('script');
        scripts.addClass('dangerous_react_rendered');
        let newContentArea = contents.prop('outerHTML');
        return (React.createElement("div", { dangerouslySetInnerHTML: { __html: newContentArea } }));
    }
}
exports.default = ContentArea;
